<template>
    <dash
        icon="fa fa-users"
        titulo="TOTAL DE ACESSOS NO MÊS"
        :qtd="qtd"
        :loading="loading"
        color="#4DA2F8"
    ></dash>
</template>

<script>
import Dash from '@/shared/components/DashComponent2'

export default {
	props: {
		qtd: {
			type: Number
		},

		loading: {
			type: Boolean
		}
	},

	components: {
		Dash
	},

	data() {
		return {}
	}
}
</script>
